import { ASSETS_API_URL } from "config/api";
import { showApiError, showApiSuccess, showFormError } from "config/apiToast";
import { NETWORK_FIELDS, buildNetworkPayload, validateNetworkForm } from "./networkFields";
import React, { useEffect, useState } from 'react'
import "./dashboard.scss";
import Dropdown from 'react-bootstrap/Dropdown';
import axios from 'axios';

const Addnetwork = () => {

    const [market, setMarket] = useState([]);
    const [Chains, setChains] = useState([]);
    const [marketid, setMarketID] = useState("");
    const [chainid, setChainID] = useState("");
    const [Marketname, setMarketname] = useState("");
    const [Chianname, setChianname] = useState("");
    const [minConfirmations, setMinConfirmations] = useState("");
    const [minDeposit, setMinDeposit] = useState("");
    const [minWithdraw, setMinWithdraw] = useState("");
    const [maxWithdraw, setMaxWithdraw] = useState("");
    const [decimals, setDecimals] = useState("");
    const [errors, setErrors] = useState({});
    const [active, setActive] = useState(false);
    const [isToken, setIsToken] = useState(false);

    const getDataMArket = async () => {
        const tok = localStorage.getItem("accessTokenDash");
        setMarket([]);

        var config = {
            method: "get",
            // isMinimal returns id, name, symbol and icon, which is all this
            // picker needs. The full list is heavier and currently fails.
            url: `${ASSETS_API_URL}/markets?isMinimal=true&page=${1}&limit=${20}`,
            headers: {
                authorization: `Bearer ${tok}`
            },
        };

        axios(config)
            .then(function (response) {
                setMarket(response?.data?.data); // Assuming the tasks array is nested inside data
            })
            .catch(function (error) {
              console.error("Error fetching data:", error);
              showApiError(error);
            });
    };

    useEffect(() => {
        getDataMArket();
    }, []);


    const getDataChains = async () => {
        const tok = localStorage.getItem("accessTokenDash");
        setChains([]);
        var config = {
            method: "get",
            url: `${ASSETS_API_URL}/chains?page=1&limit=20`,
            headers: {
                authorization: `Bearer ${tok}`
            },
        };

        axios(config)
            .then(function (response) {
                setChains(response?.data?.data); // Assuming the tasks array is nested inside data
                // setTotalPages(response?.data?.pagination?.pageCount); // Assuming the total page count is returned
            })
            .catch(function (error) {
              console.error("Error fetching data:", error);
              showApiError(error);
            });
    };

    useEffect(() => {
        getDataChains();
    }, []);

    const handleCategoryChange = (item) => {
        setErrors((prevErrors) => ({
            ...prevErrors,
            marketid: undefined,
        }));
        setMarketID(item?.id)
        setMarketname(item);
    };

    const handleCategoryChangeS = (item) => {
        setErrors((prevErrors) => ({
            ...prevErrors,
            chainid: undefined, // Remove the error message for the market icon
        }));
        setChainID(item?.id)
        setChianname(item);
    };

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        // Clear the error for the current input field
        setErrors((prevErrors) => ({
            ...prevErrors,
            [id]: undefined, // Remove the error message for the current input field
        }));

        // Handle setting state based on input ID
        switch (id) {
            //   case "marketName":
            //     setMarketName(value);
            //     break;
            //   case "marketBase":
            //     setMarketBase(value);
            //     break;
            // case "marketQuote":
            //   setMarketQuote(value);
            //   break;
            // case "Contractaddress":
            //   setCoontractaddress(value);
            //   break;
            //   case "coinID":
            //     setCoinID(value);
            //     break;
            //   case "dailyWithdrawLimit":
            //     setDailyWithdrawLimit(value);
            //     break;
            case "minConfirmations":
                setMinConfirmations(value);
                break;
            case "minDeposit":
                setMinDeposit(value);
                break;
            case "minWithdraw":
                setMinWithdraw(value);
                break;
            case "maxWithdraw":
                setMaxWithdraw(value);
                break;
            case "decimals":
                setDecimals(value);
                break;
            default:
                break;
        }
    };

    const handleSubmit = async () => {
        let tok = localStorage.getItem("accessTokenDash");

        const form = {
            marketId: marketid,
            chainId: chainid,
            minConfirmations,
            minDeposit,
            minWithdraw,
            maxWithdraw,
            decimals,
            isToken,
        };
        const formErrors = validateNetworkForm(form);

        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
            showFormError();
            return;
        }

        // The service wants marketId and chainId as strings and the amounts
        // as decimal strings; buildNetworkPayload handles that.
        const requestBody = buildNetworkPayload(form);

        var config = {
            method: "POST",
            url: `${ASSETS_API_URL}/networks`,
            headers: {
                authorization: `Bearer ` + tok
            },
            data: requestBody,
        };
        axios(config)
            .then(function (response) {
                showApiSuccess("Network Added Successfully");
                // setMarketName("");
                // setMarketBase("");
                // setMarketQuote("");
                // setChain("");
                // setCoinID("");
                // setid("");
                // setDailyWithdrawLimit("");
                setMinConfirmations("");
                setMinDeposit("");
                setMinWithdraw("");
                setMaxWithdraw("");
                // setCoontractaddress("");
                // setEssential(false);
                // setListed(false);
                // setAvailable(false);
                // setIsToken(false);
                // setPreview(null);
                // history.push("market");

                // console.log("response we get", response)
            })
            .catch(function (error) {
              showApiError(error);
            });
    };

    return (
        <>
            <img className='elipse img-fluid' src='/assets/main-assets/Ellipse.png' alt="ellipse" />
            <div className="content">
                <div className="tokenicon">
                    <div className='parentheadingnetwok'>
                        <p>Markets</p>
                        <div className='shghsdhsdhgj drop'>
                            <div className="dropdown buttons-list-all">
                                <button className="" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <p className="dvhjbdhjefv">{Marketname?.name ? Marketname?.name : 'Select Market'} {Marketname ? `(${Marketname?.symbol})` : ""} </p>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
                                        <path d="M9.29226 0.5H5.21637H1.5461C0.918037 0.5 0.604004 1.25891 1.04888 1.70379L4.43783 5.09274C4.98084 5.63575 5.86406 5.63575 6.40708 5.09274L7.69592 3.80389L9.79602 1.70379C10.2344 1.25891 9.92033 0.5 9.29226 0.5Z" fill="white" />
                                    </svg>
                                </button>

                                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    {market?.map((elem, index) => (
                                        <a key={index} className="dropdown-item" onClick={() => handleCategoryChange(elem)}><p>{elem.name} {`(${elem.symbol})`}</p></a>
                                    ))}
                                </div>
                            </div>
                        </div>
                        {errors.marketid && <p className="error">{errors.marketid}</p>}
                        <p>Chain</p>
                        <div className='drop'>
                            <div className='shghsdhsdhgj drop'>
                                <div className="dropdown buttons-list-all">
                                    <button className="" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <p className="dvhjbdhjefv">{Chianname?.name ? Chianname?.name : 'Select Chain'} {Chianname ? `(${Chianname?.standard})` : ""} </p>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
                                            <path d="M9.29226 0.5H5.21637H1.5461C0.918037 0.5 0.604004 1.25891 1.04888 1.70379L4.43783 5.09274C4.98084 5.63575 5.86406 5.63575 6.40708 5.09274L7.69592 3.80389L9.79602 1.70379C10.2344 1.25891 9.92033 0.5 9.29226 0.5Z" fill="white" />
                                        </svg>
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        {Chains?.map((elem, index) => (
                                            <a key={index} className="dropdown-item" onClick={() => handleCategoryChangeS(elem)}><p>{elem.name} {`(${elem.standard})`}</p></a>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {errors.chainid && <p className="error">{errors.chainid}</p>}

                    </div>
                    <div className='maininputs'>
                        <p className="inputtextttt">Min Confirmations</p>
                        <input type="text" inputMode="numeric" placeholder={NETWORK_FIELDS.minConfirmations.placeholder} className="inputttclass" id="minConfirmations" value={minConfirmations} onChange={handleInputChange} />
                        {errors.minConfirmations
                            ? <p className="error">{errors.minConfirmations}</p>
                            : <p className="pairfieldhint">{NETWORK_FIELDS.minConfirmations.hint}</p>}
                        <p className="inputtextttt">Min Deposit</p>
                        <input type="number" placeholder="Min Deposit (e.g. 10)" className="inputttclass" id="minDeposit" value={minDeposit} onChange={handleInputChange} />
                        {errors.minDeposit && <p className="error">{errors.minDeposit}</p>}
                        <p className="inputtextttt">Min Withdraw</p>
                        <input type="number" placeholder="Min Withdraw (e.g. 1000)" className="inputttclass" id="minWithdraw" value={minWithdraw} onChange={handleInputChange} />
                        {errors.minWithdraw && <p className="error">{errors.minWithdraw}</p>}
                        <p className="inputtextttt">{NETWORK_FIELDS.maxWithdraw.label}</p>
                        <input type="text" inputMode="decimal" placeholder={NETWORK_FIELDS.maxWithdraw.placeholder} className="inputttclass" id="maxWithdraw" value={maxWithdraw} onChange={handleInputChange} />
                        {errors.maxWithdraw
                            ? <p className="error">{errors.maxWithdraw}</p>
                            : <p className="pairfieldhint">{NETWORK_FIELDS.maxWithdraw.hint}</p>}
                        <p className="inputtextttt">{NETWORK_FIELDS.decimals.label}</p>
                        <input type="text" inputMode="numeric" placeholder={NETWORK_FIELDS.decimals.placeholder} className="inputttclass" id="decimals" value={decimals} onChange={handleInputChange} />
                        {errors.decimals
                            ? <p className="error">{errors.decimals}</p>
                            : <p className="pairfieldhint">{NETWORK_FIELDS.decimals.hint}</p>}
                    </div>
                    <div className="listedhead forwidthsss">
                        <p className="availtab">Is Token</p>
                        <label className="switch">
                            <input type="checkbox" checked={isToken} onChange={() => setIsToken(!isToken)} />
                            <span className="slider round"></span>
                        </label>
                    </div>
                    <div className="listedhead forwidthsss">
                        <p className="availtab">Is Active</p>
                        <label className="switch">
                            <input type="checkbox" checked={active} onChange={() => setActive(!active)} />
                            <span className="slider round"></span>
                        </label>
                    </div>
                    <div className='addmarketbuttonsss'>
                        <button type='button' onClick={handleSubmit}>Add Network</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Addnetwork
